<template>
    <div v-if="isToggledRepsHistory">
        <div class="reps_card" v-if="sections.length == 0">
            <div class="row">
            <div class="col-12 text-align-center">No data found!</div>
            </div>
        </div>
        <div class="reps_card" v-for="(item, index) in sections" :key="index" v-else>
            <div class="row">
                <div class="col-11">{{ item.text }}</div>
            </div>
            <div class="row" style="font-style: italic; font-size: 12px;">
                <div class="col-12 text-align-right">Updated by: {{ item.created_by }} on {{ item.created_at | formatDate }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});


export default {
    props: [
        'sectionId',
        ],
    data() {
        return{
            sections: [],
            isToggledRepsHistory: false,
        }
    },
    methods: {
        fetchSectionsHistory() {
            if (!this.isToggledRepsHistory) {
                
                this.$parent.toggleFontIcon = 'fa fa-angle-up';
                axios.get('/assessment-section-audit-trail/' + this.sectionId)
                .then(response =>  {
                    this.sections = response.data;
                    this.isToggledRepsHistory = true;
                })
                .catch(() => {
                    console.log("error comes")
                });
            } else {
                this.hideRepsHistory();
            }
        },
        hideRepsHistory() {
            this.isToggledRepsHistory = false;
            this.$parent.toggleFontIcon = 'fa fa-angle-down';
            this.sections = [];
        }
    }
}
</script>
<style scoped>
.reps_card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/section_history.vue